import { render, staticRenderFns } from "./CommissionExtracts.vue?vue&type=template&id=7a5c4a32&"
import script from "./CommissionExtracts.vue?vue&type=script&lang=js&"
export * from "./CommissionExtracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports